import { Navigate } from "react-router-dom";

export default function ProtectedAdminRoute({children}){

  const isAdmin = localStorage.getItem("flyerAdmin")

  if(!isAdmin){
    return <Navigate to="/flyer-admin" replace />
  }

  return children
}